export const STAGES = [
  { value: "Progettazione", progress: 20 },
  { value: "Rilievo e capitolato", progress: 40 },
  { value: "Cantiere", progress: 60 },
  { value: "Finiture", progress: 85 },
  { value: "Completato", progress: 100 },
];

export const SECTIONS = [
  {
    key: "capitolato",
    label: "Capitolato",
    hint: "Documento descrittivo dell'intervento",
    ai: true,
    aiLabel: "Genera capitolato con AI",
  },
  {
    key: "sopralluogo",
    label: "Sopralluogo e rilievo",
    hint: "Note e documentazione del rilievo",
  },
  {
    key: "computo_metrico",
    label: "Computo metrico",
    hint: "Voci di computo e importi",
    columns: [
      { key: "voce", label: "Voce" },
      { key: "descrizione", label: "Descrizione" },
      { key: "um", label: "U.M." },
      { key: "quantita", label: "Quantità" },
      { key: "prezzo", label: "Prezzo unit. €" },
      { key: "totale", label: "Totale €" },
    ],
  },
  {
    key: "dwg",
    label: "DWG da inserire",
    hint: "File tecnici DWG/DXF e planimetrie",
  },
  {
    key: "render",
    label: "Render",
    hint: "Immagini di render e visualizzazioni 3D",
  },
  {
    key: "fornitori",
    label: "Fornitori e showroom",
    hint: "Anagrafica fornitori e showroom",
    columns: [
      { key: "nome", label: "Nome" },
      { key: "categoria", label: "Categoria" },
      { key: "contatto", label: "Contatto" },
      { key: "indirizzo", label: "Indirizzo" },
      { key: "note", label: "Note" },
    ],
  },
  {
    key: "mobili",
    label: "Mobili siti low-cost",
    hint: "Prodotti e link a siti economici",
    columns: [
      { key: "prodotto", label: "Prodotto" },
      { key: "sito", label: "Sito" },
      { key: "prezzo", label: "Prezzo €" },
      { key: "link", label: "Link" },
      { key: "note", label: "Note" },
    ],
  },
  {
    key: "interventi",
    label: "Interventi e figure",
    hint: "Interventi da fare, figure, tempistiche",
    ai: true,
    aiLabel: "Genera piano con AI",
    columns: [
      { key: "intervento", label: "Intervento" },
      { key: "figura", label: "Figura incaricata" },
      { key: "tempistiche", label: "Tempistiche" },
      { key: "stato", label: "Stato" },
      { key: "note", label: "Note" },
    ],
  },
];
